import { servieModal } from './servicesListDisplayModal';
import {setProgressBar} from './setProgressBar';
export function leadSchedulerBackButton(pane:any){
    switch (pane){
        case "service-details-screen" :
            $('.tab-pane.fieldset').removeClass('active');
            $('#schedulerWizard #service-address-screen').addClass('active');
            setProgressBar("service-address-screen");
            break;
        case "service-address-screen" :
            $('.tab-pane.fieldset').removeClass('active');
            $('#schedulerWizard #contact-information-screen').addClass('active');
            setProgressBar("contact-information-screen");
            break;
        case "contact-information-screen" :
            $('.tab-pane.fieldset').removeClass('active');
            if(window.objOSGlobal.requestBodyValues.IsLeadOnly){
                let conceptId = window.objOSGlobal.requestBodyValues.ConceptCalledId;
                $('.progress, .progressbar').hide()
                $('.modal-header-two').hide();
                if(servieModal.enable && conceptId =='24'){
                    $('#dvw-splash-screen').addClass('active');
                    $('.dvw-modal-header').show();
                }else{
                    $('#schedulerWizard #service-search-page').addClass('active');
                    $('.modal-header-one').show();
                }
            } else {
                $('#schedulerWizard #calendar-screen').addClass('active');
                setProgressBar("calendar-screen");
            }
            break;       
            default :
            break;
    }
}
